import CaseStudyPage from "@/pages/portfolio/components/CaseStudyPage";

export default function HealthcareCase() {
  return <CaseStudyPage slug="healthcare-management-system" />;
}